import { BookingFormValidator } from "./booking-form-validator";

export function initCheckoutPage(paymentService: any): void {
    const $: any = (window as any).$;
    if (!$) return;

    const form = document.getElementById("EventBookingForm") as HTMLFormElement | null;
    if (!form) return;

    const terms = form.querySelector<HTMLInputElement>("#TermsAllAgreed");
    if (!terms) return;

    // Use shared validator to setup terms validation
    BookingFormValidator.setupTermsValidation("EventBookingForm");

    // Wire invoice button -> payment service method
    const invoiceBtn = document.getElementById("invoiceButton") as HTMLElement | null;
    if (invoiceBtn) {
        invoiceBtn.setAttribute("type", "button"); // hard guarantee
        invoiceBtn.addEventListener("click", (e) => {
            e.preventDefault();
            e.stopPropagation();

            if (!paymentService || typeof paymentService.submitEventInvoiceFromButton !== "function") {
                console.error("[checkout] paymentService missing submitEventInvoiceFromButton");
                return;
            }

            paymentService.submitEventInvoiceFromButton(invoiceBtn);
        });
    }

    const poInput = document.getElementById("PoNumber") as HTMLInputElement | null;
    const poError = document.getElementById("PoNumberError") as HTMLElement | null;

    if (poInput) {
        poInput.addEventListener("input", () => {
            if (poInput.value.trim().length) {
                poInput.classList.remove("input-validation-error");
                if (poError) {
                    poError.textContent = "";
                    poError.classList.add("d-none");
                }
            }
        });
    }
}